import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";

import CardActions from "@mui/material/CardActions";

import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import { Button, Grid, ListItem, } from "@mui/material";
import Rating from "@mui/material/Rating";
import './HorizontalCards.css';
import CheckIcon from '../../assets/img/check.png'

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})
(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest
  })
}));

const list = [
  "Own analytics ",
  "Chat support",
  "Optimize hashtags",
  "Unlimited users"
];

console.log(ExpandMore);


export  function HorizontalScrollCard(
  image,
  // name,
  // price,
  // list,
  // data,
) {
  // const [expanded, setExpanded] = React.useState(false);
  // const [list, setList] = React.useState(initialList);

  // console.log(data.list);
  // console.log(data.image);
  // console.log(data);
  // console.log(list.list);
  
  // console.log(data.description);
  // console.log(data.price);


  const Img = styled("img")({
    // margin: "auto",
    paddingRight: "10px",
    // display: "block",
    maxWidth: "95px",
    maxHeight: "75px",
    // paddingTop: '81.25%',
    borderRadius: "50%"
    // margin: '28px'
  });
  
  const CheckImg = styled("img")({
    // margin: "auto",
    // paddingRight: "10px",
    // display: "block",
    maxWidth: "20px",
    maxHeight: "20px",
    // paddingTop: '81.25%',
    // borderRadius: "50%"
    // margin: '28px'
  });

  return (
    <Card  
    pb={2}
      sx={{ 
        bgcolor: "#EC6607",
        height: "477px",
        width: "272px",
        boxShadow: "0px 42px 34px rgba(82, 67, 194, 0.295755)",
        borderRadius: "26px",
        // borderRadius: "8%",
        // padding: "10px",
        paddingBottom: '20px',
        // change cursor to touch
        cursor: "pointer",
        // disable highlighting on touch
        WebkitTapHighlightColor: "transparent",
        "&:hover": {
          boxShadow: "0px 38px 61px #ec6607",
        },
       
      }}
    >

      <Grid container spacing={2} px={2} pb={1} pt={2} xs={12.8}>
        <Grid item xs={8} >
          <Grid container direction="column" spacing={2} px={2} pt={4}>
            <Typography
              variant="h7"
              align="left"
              fontSize={25}
              fontWeight={400}
              fontFamily={"Roboto"}
              color={"white"}
            >
              20k Tzsh /hr
              
            </Typography>
            <Rating name="read-only" value={4} readOnly />
          </Grid>
        </Grid>
        <Grid item xs={4}  pt={0} pr={3} >
       
          <Img
            // alt={data.name}
            // src= {image}
            // src= {data.image}
            src="https://muratselek.com.tr/wp-content/uploads/2019/01/yorum-icon-avatar-768x768.png"
          />
        </Grid>
      </Grid>

        <Grid container direction="column" spacing={2} pl={4} pt={0}>
        <Grid item pr={4} pt={1} xs={12}>
          <Typography 
              variant="h7"
              align="left"
              fontSize={30}
              fontWeight={900}
              fontFamily={"Roboto"}
              color={"white"}
              >
                Anna Joe 
                {/* {name} */}
          </Typography>
          </Grid>
          <Grid container direction="column" spacing={2} pl={4} pt={2} pr={2}>
            {/* <div>  */}
          <Typography 
              variant="h7"
              align="left"
              fontSize={15}
              fontWeight={500}
              lineHeight={"17.5px"}
              fontFamily={"Roboto"}
              color={"white"}
              >
                For most businesses that want to optimize web queries. also i hae d too the following arrow. 
          </Typography>
          {/* </div> */}
          </Grid>
          <Grid pr={2} pt={1}>
         
                {/* <div> */}
                  
                    {list.map(item => (
                      <>
                      {/* <li key={item}>{item}</li> */}
                      <ListItem >
                     
                        <CheckImg
                          alt="complex"
                          src={CheckIcon}
                          
                        />
                       
                        <Typography 
              variant="h7"
              align="left"
              fontSize={15}
              fontWeight={500}
              fontFamily={"Roboto"}
              color={"white"}
              paddingLeft={'6px'}
              // lineHeight={17.5}
              >
                {item}               
                 </Typography>
                      </ListItem>
                      
                      </>
                    ))}

          </Grid>

        </Grid>

      <CardActions disableSpacing>
      <Grid container direction="row" spacing={2} px={2} pt={0} >
          <Grid item xs={12} pr={0}>
          <Button
              variant="contained"
              color="secondary"
              size="small"
              style={{
                backgroundColor: "#fff",
                borderRadius: "50px",
                color: "#EC6607",
                fontSize: "15px",
                width: "100%",
                fontWeight: "900",
                fontFamily: "Roboto",
                padding: "10px",                
                marginTop: "10px",
                marginBottom: "10px",
                // paddingLeft: '10px',
                
                // background-color: rgb(236, 102, 7);
                // border-radius: 50px;
                // width: 224px;
                // padding-left: 0px;
                // white: ;
                // font-size: 14px;
                // font-weight: bold;
                // padding: 10px;
                
              }}
            >
              Book Now
            </Button>
          </Grid>
          </Grid>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore> */}
      </CardActions>
    </Card>
  );
}
